import { render, staticRenderFns } from "./transferred-calls.vue?vue&type=template&id=dd92161c&"
import script from "./transferred-calls.vue?vue&type=script&lang=js&"
export * from "./transferred-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports